// extracted by mini-css-extract-plugin
module.exports = {"balanceSpan":"posDashboard_balanceSpan__3xSi6","balanceDisclaimer":"posDashboard_balanceDisclaimer__2QPeV"};